export default __webpack_public_path__ + "static/media/3.bef5dd94.jpg";